<template>
    <div class="part">
        <p>{{ $t("Always providing great services") }}</p>
        <span>
            {{
                $t(
                    "Please visit our twitter account to be updated with our latest offers"
                )
            }}
        </span>
        <div class="center-text">
            <a
                class="button is-primary"
                href="https://twitter.com/BAREDEXSA"
                target="_blank"
                >{{ $t("More details") }}</a
            >
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        setAction() {
            this.$buefy.toast.open({
                message: this.$t("Coming Soon!"),
                type: "is-primary",
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.part {
    width: 100%;
    height: 100%;
    text-align: left;

    p {
        font-weight: bold;
        font-size: 2.4rem;
        line-height: 1.2;
        margin-bottom: 40px;
    }

    span {
        display: inline-block;
        margin-bottom: 40px;
    }

    .center-text {
        text-align: center;
    }
}
</style>
